import FindAnimal from "../../components/Nursery/EnvironmentScience/FindAnimal";
import MatchAnimal from "../../components/Nursery/EnvironmentScience/MatchAnimal";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - Nursery - Environmental Science - Animal"; // Set page title

const topics: MenuItem[] = [
    { url: "/nursery/environmental-science/animal/find-animal", title: "Find Animal", component: FindAnimal},
    { url: "/nursery/environmental-science/animal/match-animal", title: "Match Animal", component: MatchAnimal},
];


export default topics;